import { createTheme } from '@mui/material';
import { ruRU } from '@mui/material/locale';

import { ThemeMode } from '../types/theme';
import lightPalette from './light';
import darkPalette from './dark';

const createAppTheme = (mode: ThemeMode) => {
    return createTheme(
        {
            components: {
                MuiMenuItem: {
                    defaultProps: {
                        dense: true,
                    },
                },
                MuiTypography: {
                    styleOverrides: {
                        root: ({ theme }) => ({
                            color: theme.palette.text.primary,
                        }),
                    },
                },
                // Убираем белый elevation-overlay MUI в тёмной теме —
                // именно он делает диалоги серыми вместо тёмно-синих.
                MuiPaper: {
                    styleOverrides: {
                        root: ({ theme }) => ({
                            ...(theme.palette.mode === 'dark' && { backgroundImage: 'none' }),
                        }),
                    },
                },
                // Содержимое диалога — темнее рамки (background.default)
                MuiDialogContent: {
                    styleOverrides: {
                        root: ({ theme }) => ({
                            ...(theme.palette.mode === 'dark' && {
                                backgroundColor: theme.palette.background.default,
                            }),
                        }),
                    },
                },
                // Sticky-шапка таблицы — явный цвет, иначе сливается с контентом
                MuiTableCell: {
                    styleOverrides: {
                        stickyHeader: ({ theme }) => ({
                            backgroundColor: theme.palette.background.paper,
                        }),
                    },
                },
            },
            palette: mode === 'dark' ? darkPalette : lightPalette,
        },
        ruRU,
    );
};

export default createAppTheme;
